export default "__VITE_ASSET__4f19acd5__"